import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/yearsIncomeReport'
import { getYearsIncomeReport as getYearsIncome } from 'services'

const {
  YEARS_REQUEST,
  YEARS_SUCCESS,
  YEARS_ERROR
} = ACTION_TYPES

export function *getYearsIncomeReport() {
  try {
    const response = yield call(getYearsIncome)
    yield put({ type: YEARS_SUCCESS, payload: response.data })
  } catch (err) {
    yield put({ type: YEARS_ERROR, payload: err })
  }
}

export default function *watchYearsIncomeReport() {
  yield takeLatest(YEARS_REQUEST, getYearsIncomeReport)
}
